module.exports = __webpack_public_path__ + "img/dollar-symbol_icon-icons.com_73598.c465f7c0.svg";